import { Component, OnInit, ViewChild } from '@angular/core';
import { DashboarduiService } from '../../Shared/Service/dashboardui.service';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { ToastrService } from 'ngx-toastr';
import { LocalstorageService } from '../../Shared/Service/localstorage.service';
import { Router } from '@angular/router';
import { ExcelServicesService } from '../../Shared/Service/excel-services';
import { DatePipe } from '@angular/common';
export class idsProductList {
  CHANNELNAME:any;
  ProductName:any;
  FX_Count:any;
  FN_Count:any;
  Total:any;
}
@Component({
  selector: 'app-dhproductsummarydetails',
  templateUrl: './dhproductsummarydetails.component.html',
  styleUrls: ['./dhproductsummarydetails.component.css']
})
export class DhproductsummarydetailsComponent implements OnInit {

  constructor(  private datePipe: DatePipe,private excelService: ExcelServicesService,
    public router:Router,private apiCallIdsService: DashboarduiService,
    private toaster:ToastrService,private  localStorage: LocalstorageService)
     { }
     channelManagerData: any[] = [];
     produtData:any[]=[];
     channelManagerDetails: any[] = [];
     productDetails:any[]=[];
     selectedChannelDetails: any[] = [];
     countList:any[];
     dataSource!: MatTableDataSource<idsProductList>;  
     public idsProductList: idsProductList[];
     isProgressing: Boolean = false;
     filterProperty: any;
     errorMsgSubscription: boolean;
     errorMessage: string;
     totalcount: any = 0;
     displayContent: boolean;
     Userid: any = [];
     excelFunction: boolean = false;
     filteredDetails: any[] = [];
     ValSearchDownload: string;
     channelName: string = '';
     ProductName:string='';
     @ViewChild('channelPaginator', { static: true }) channelPaginator: MatPaginator;
     @ViewChild('channelSort', { static: true }) channelSort: MatSort;
     @ViewChild('productPaginator', { static: true }) productPaginator: MatPaginator;
     @ViewChild('productSort', { static: true }) productSort: MatSort;
     displayedColumns: string[] = ['CHANNELNAME', 'FX_Count', 'FN_Count', 'Total'];
     productlistdisplayedColumns:string[]=['ProductName', 'FX_Count', 'FN_Count', 'Total']
     channelManagerDataSource = new MatTableDataSource([]);
     productDataSource=new MatTableDataSource([]);
     request:any;
  ngOnInit() {
    this.callIDSUsersProperties();
  }
  callIDSUsersProperties() {
    this.apiCallIdsService.readdhsummarydetails()
      .subscribe(data => {
        console.log('New Screen Data', data);
        if (data && data.ChannelManagerCount && data.ChannelManagerCount.length > 0) {
          this.channelManagerDataSource.data = data.ChannelManagerCount;
          this.channelManagerDataSource.paginator = this.channelPaginator;
          this.channelManagerDataSource.sort = this.channelSort;
          console.log('this.channelPaginator',this.channelManagerDataSource.paginator)
          console.log('channelManagerDataSource.sort',this.channelSort)
          console.log('channelManagerDataSource.data',this.channelManagerDataSource.data)
          this.channelManagerData = data.ChannelManagerCount.map(item => ({item,
            FX_Count: item.FX_Count || 0,
            FN_Count: item.FN_Count || 0,
            Total:item.Total||0
          }));
          this.channelManagerData = data.ChannelManagerCount;
          this.channelManagerDetails = data.ChannelManagerDetails; 
          this.filteredDetails = this.productDetails.filter(detail => detail.channelName === this.channelName);
          console.log("Filterdetailschannel",this.filteredDetails);
        } 
        else {
          this.toaster.error('No Data Found');
        }
         console.log("Productdata",data.ProductDetails);
          if(data && data.ProductCount && data.ProductCount.length > 0)
          {
            this.productDataSource.data=data.ProductCount;
            this.productDataSource.paginator = this.productPaginator;
            this.productDataSource.sort=this.productSort;
            console.log('this.productPaginator;',this.productDataSource.paginator)
            console.log('productDataSource.data',this.productDataSource.data)
            console.log('productDataSource.sort',this.productSort)
            this.produtData = data.ProductCount.map(item => ({item,
              FX_Count: item.FX_Count || 0,
              FN_Count: item.FN_Count || 0,
              Total:item.Total||0
            }));
          
          this.produtData=data.ProductCount;
          this.productDetails=data.ProductDetails;
          this.filteredDetails = this.productDetails.filter(detail => detail.ProductName === this.ProductName);
          console.log("FilterdetailsProduct",this.filteredDetails);
        }
        else {
          this.toaster.error('No Data Found');
        } 
        console.log('Updated statisticsData', this.channelManagerData);
        console.log('channelManagerDetails',this.channelManagerDetails);
        this.excelFunction = true
        this.toaster.success('Data loaded Successfully');
      });
  }
  addNewRec(channelName: string){
    console.log("channelname",channelName);
   
    this.router.navigate(['/DHProductSummaryDetails/listdhproductsummarydetails',{ CHANNELNAME: channelName }])
    this.localStorage.removeKey('getToFindEditDataKey')
    this.localStorage.setKey('getHotelEditDataKey',false)
  }
  ProductaddNewRec(Productname: string){
    console.log("channelname",Productname);
    this.router.navigate(['/DHProductSummaryDetails/listdhproductsummarydetails',{ ProductName: Productname }])
    this.localStorage.removeKey('getToFindEditDataKey')
    this.localStorage.setKey('getHotelEditDataKey',false)
  }
  filterResults() {
    const filterValue = this.ValSearchDownload.trim().toLowerCase();
    
    // Apply filter to both tables
    this.channelManagerDataSource.filter = filterValue;
    this.productDataSource.filter = filterValue;
  }
  exportAsXLSX() {
    this.Userid = localStorage.getItem("Username");
    console.log(this.Userid)
    var filterArray = [];
    var listfilterArrary=[];
    var productcountArray=[];
    var listproductdetailsArrary=[];
    var slno = 1;
    const excelTitle = "DH Product Summary Details";
    const excelDownloadTitle = "DH Product Summary Details";
    const title = "Title: " + excelTitle;
    const role = "Role: " + "IDS User";
    const bindFirstName = "EmailId: " + this.Userid;

    const header = ['ID','CHANNELNAME', 'FN_Count', 'FX_Count','Total'];
    for (var i in this.channelManagerData) {
      filterArray.push([
         this.channelManagerData[i].ID,this.channelManagerData[i].CHANNELNAME,
         this.channelManagerData[i].FN_Count, this.channelManagerData[i].FX_Count,
         this.channelManagerData[i].Total
      ])
      slno = slno + 1;
    }
    const header1 = ['ID','CHANNELNAME', 'HotelCode', 'HotelName','HotelCity','IsFX'];
    for (var j in this.channelManagerDetails) {
      listfilterArrary.push([
         this.channelManagerDetails[j].ID,this.channelManagerDetails[j].CHANNELNAME,
         this.channelManagerDetails[j].HotelCode, this.channelManagerDetails[j].HotelName,
         this.channelManagerDetails[j].HotelCity,this.channelManagerDetails[j].IsFX
      ])
      slno = slno + 1;
    } 
    const header2=['ID','ProductName', 'FN_Count', 'FX_Count','Total']
    for (var i in this.produtData) {
      productcountArray.push([
         this.produtData[i].ID,this.produtData[i].ProductName,
         this.produtData[i].FN_Count, this.produtData[i].FX_Count,
         this.produtData[i].Total
      ])
      slno = slno + 1;
    }
    const header3=['ID','ProductName', 'HotelCode', 'HotelName','HotelCity','IsFX']
    for (var j in this.productDetails) {
      listproductdetailsArrary.push([
        this.productDetails[j].ID,this.productDetails[j].ProductName,
        this.productDetails[j].HotelCode, this.productDetails[j].HotelName,
        this.productDetails[j].HotelCity,this.productDetails[j].IsFX
      ])
      slno = slno + 1;
    }
    this.excelService.dhproductsummarydetails(filterArray,listfilterArrary,productcountArray,listproductdetailsArrary, 
      bindFirstName, title, role, header,header1,header2,header3, excelTitle, excelDownloadTitle);
  }
}
